const BottomShape02 = () => {

    return (<div className="rmdr-bottom-shape-02" />)

}

export default BottomShape02;
